/**
 * Module dependencies.
 */

import { Select } from 'app/components/atoms/forms/fields/select/select';
import { useGetCCICodes } from 'app/hooks/app-requests/ccis/use-get-cci-codes';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * `Props` type.
 */

type Props = {
  name: string;
  value: any;
  onChange?: (value: any, item?: any) => void;
};

/**
 * Export `CCISearchInput` component.
 */

export function CCISearchInput({ name, value, onChange }: Props): JSX.Element {
  const [searchValue, setSearchValue] = useState<string>('');
  const { data } = useGetCCICodes(searchValue);
  const [translate] = useTranslation();
  const options = useMemo(
    () =>
      data?.map(item => ({
        value: item.cci,
        label: item.cci,
        searchValue: item.cci
      })) ?? [],
    [data]
  );

  const filterOption = useCallback((input: any, option: any) => {
    return String(option?.value ?? '')
      .toLowerCase()
      .startsWith(input.toLowerCase());
  }, []);

  return (
    <Select
      allowClear
      filterOption={filterOption}
      name={name}
      onChange={onChange}
      onSearch={setSearchValue}
      options={options}
      placeholder={translate('common.labels.cciSearch')}
      showSearch
      value={value}
    />
  );
}
